import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";

const TablePaginationReuse = (props) => {
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const { data, tableHead, videoType, auditionRoundInfo } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className="py-3">
        <div className="row mx-1" style={{ overflowX: "auto" }}>
          <Table className="table w-100" striped bordered hover variant="dark">
            <thead>
              <tr>
                {tableHead &&
                  tableHead.map((heading) => (
                    <th className="bg-warning text-center">{heading}</th>
                  ))}
              </tr>
            </thead>

            <tbody>
              {currentItems ? (
                currentItems.map((user, index) => (
                  <tr key={index}>
                    <td>
                      {user.participant?.first_name}
                      {user.participant?.last_name}
                    </td>
                    <td>{user.participant?.email}</td>
                    <td>
                      <div>
                        {user?.videos?.map((video, index) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-primary ml-1"
                          >
                            Video -{`${index + 1}`} :
                            {video?.judge_video_mark
                              ?.reduce(
                                (prevMark, currMark, index, judge_video_mark) =>
                                  prevMark +
                                  currMark.judge_mark / judge_video_mark.length,
                                0
                              )
                              .toFixed(2)}
                          </span>
                        ))}
                        {videoType === "general" ? (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg:
                              {(
                                user?.videos?.reduce(
                                  (a, v) =>
                                    (a =
                                      a +
                                      v?.judge_video_mark?.reduce(
                                        (
                                          prevMark,
                                          currMark,
                                          index,
                                          judge_video_mark
                                        ) => {
                                          return (
                                            prevMark + currMark.judge_mark / 3
                                          );
                                        },
                                        0
                                      )),
                                  0
                                ) / auditionRoundInfo?.video_slot_num
                              ).toFixed(2)}
                            </span>
                          </>
                        ) : (
                          "00"
                        )}
                      </div>
                    </td>

                    <td>
                      {user?.videos?.map((video, index) => (
                        <span
                          key={index}
                          className="badge rounded-pill bg-primary ml-1"
                        >
                          Video ~{`${index + 1}`} :
                          {video?.total_user_vote_react?.map((react) => {
                            return react.react_num;
                          })}
                        </span>
                      ))}
                    </td>

                    <td>
                      <div>
                        {user?.videos?.map((video, index) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-primary ml-1"
                          >
                            Video -{`${index + 1}`} :
                            {video.user_judge_total_mark}
                          </span>
                        ))}
                        {videoType === "general" ? (
                          <>
                            <span className="badge rounded-pill bg-info ml-1">
                              Avg :
                              {(
                                user?.videos?.reduce(
                                  (prevMark, currMark) =>
                                    (prevMark =
                                      prevMark +
                                      (currMark.user_judge_total_mark == null
                                        ? 0
                                        : Number(
                                            currMark.user_judge_total_mark
                                          ))),
                                  0
                                ) / auditionRoundInfo.video_slot_num
                              ).toFixed(2)}
                            </span>
                          </>
                        ) : (
                          "00"
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <h3 className="text-danger">No Data Found</h3>
                </>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <div id="react-paginate">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};

export default TablePaginationReuse;
